module.exports = __webpack_public_path__ + "static/media/DIN-RegularAlternate.1d4468c3.woff2";